export default {
  filterCommonLoading: "加載中. ..",
  filterCommonNoData: "暫無數據",

  hiringLocation: "雇傭地點",
  dateRange: "時間區域",
  marketGalleries: "種類",
  marketGalleriesPlaceholder: "請輸入種類",
  marketCategories: "分類",
  marketCategoriesPlaceholder: "請輸入分類",
  newsLocations: "新聞位置",
  publishedDateRange: "發表時間區域",
  industryCategories: "行業分類",
  industryCategoriesPlaceholder: "請輸入行業分類",
  industrySubCategories: "子行業",
  sequencePlaceholder: "請輸入工作流程名稱",
  pageviewGreaterThan: "頁面流覽量",
  sessionGreaterThan: "會話數",
  advertisements: "廣告",
  accountLocation: "帳戶地址",
  startDate: "開始時間",
  endDate: "結束時間",
  inputNumberMin: "最小",
  inputNumberMax: "最大",
  postingLocation: "發佈地點",

  filterJob: "工作",
  filterJobPostingDateSubTitle: "發佈時間段",
  filterJobPostingLocation: "發佈地點",
  filterJobTitlesSubTitle: "職位名稱",

  filterNews: "新聞",
  filterNewsPublishedDateSubTitle: "發佈時間段",
  filterNewsCategories: "分類",

  filterEmployeeCustomRange: "自定義範圍",

  filterAdvancedSearch: "高级搜索",
  allSearchResultsFor: '"{count}" 的所有搜索结果',
  filterAdvancedSearchTooltip: "按含義查找結果，而不僅僅是精確的單詞。",

  filterSpecialties: "專長",
  filterSpecialtiesPlaceHolder: "請輸入專長",

  filterIndustrySubCategories: "子行業",
  filterIndustrySubCategoriesPlaceHolder: "請輸入子行業",

  filterAdPlaceholder: "請輸入廣告名稱",

  filterEmployeesPlaceholder: "請選擇員工數量",

  filterLocationExcludeText: "排除所選位置",
  filterLocationExcludeTooltip: "啟用後，這些位置將從結果中過濾掉。",
  filterManagementPlaceholder: "輸入管理層級別",

  filterJobFunctionPlaceholder: "輸入職務功能",

  filterDepartmentPlaceholder: "输入部门",

  filterPage: "頁面",
  filterPerPage: "每頁頁數",

  filterCompanyPlaceHolder: "輸入公司",
  filterCompanyCSVImport: "輕鬆導入您已有的公司清單",
  filterCompanyCSVText: "導入公司清單（CSV）",

  csvComponentTitle1: "上傳 CSV",
  csvComponentTitle2: "檢閱上傳內容",
  csvTipNeedHelp: "需要協助嗎？",
  detectFileNumber: "偵測到 {count} 間公司",
  uploadLoading: "上傳中...",
  uploadReplace: "替換",
  noCompaniesWereDetectedInYourFile:
    "檔案中未偵測到公司資料。請檢查您的數據並重新上傳。",
  fileContainsManyCompanies: "您的檔案包含許多公司，將只使用前{count}個。",
  onlyReturnOneResultPerCompany: "每間公司只會返回 1 項結果",
  btnViewCompanyList: "檢視公司列表",
  csvFileAnalysisFailed: "CSV 檔案分析失敗，請稍後再試",
  downloadFailed: "下載失敗，請重試。",
  downloadSampleCsv: "下載 CSV 樣本",
  firstHundredEntriesWillBeProcessed: "每個檔案只會處理首{count}項記錄。",
  detectingCompaniesInFile: "正在檢測檔案中的公司。。。",
  thisMayTakeAFewSeconds: "這可能需要幾秒鐘的時間。",

  filterSaveText: "保存搜索條件",
  filterClearAllText: "清除全部",

  filterRemoved: "篩選條件已移除",
};
